module.exports = __webpack_public_path__ + "img/flag-united-states.602993cf.png";